import { availableButtonClickEvent } from "./availableButtonClickEvent";
import { updateTimeSlots } from "./updateTimeSlots";

export function updateCalendarAvailability() {
  let calendarNumbers = document.querySelectorAll('.calendar-number');
  calendarNumbers.forEach((e) => {
    e.classList.remove('available');
    e.classList.remove('selected');
  });

  let appointmentDuration = window.document.querySelector('p[data-appointment-length]');
  if (!appointmentDuration) { return updateCalendarAvailability(); }
  let appointmentLength = appointmentDuration.dataset.appointmentLength;
  let tokenNode = document.querySelector('meta[name="csrf-token"]');
  const TOKEN = (tokenNode) ? tokenNode.getAttribute('content') : null;
  const url = `/update_availability?appointment_length=${encodeURIComponent(appointmentLength)}`;

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'applicaton/json',
      'Accept': 'applicaton/json',
      'X-CSRF-Token': TOKEN,
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('There was a problem with the request.')
    }
    return response.json();
  }).then(data => {
    console.log(data)
    for (let i = 0; i < data.length; i++) {
      let dateNode = document.getElementById(data[i]);

      if (!dateNode) {
        console.log(`No dateNode for ${data[i]}`)
        continue;
      }

      dateNode.classList.add('available');
    }
    const dateInput = document.querySelector('input[name="date"]');
    dateInput.value = '';
    availableButtonClickEvent();
    updateTimeSlots();
  }).catch((error) => {
    console.log('Update calendar availability error:');
    console.log(error);
  });
}
